// src/templates/PageTemplate.jsx
import React from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

function LinearLoader() {
  return (
    <div className="fixed top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 animate-[loading_2s_linear_infinite] z-50">
      <style>{`
        @keyframes loading {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}

export default function PageTemplate({
  title,
  content,
  loading = false,
  className = "",
  style = {},
  ...props
}) {
  return (
    <div
      className={`min-h-screen flex bg-gray-50 ${className}`}
      style={style}
      {...props}
    >
      <Sidebar />
      <main className="flex-1 flex flex-col overflow-hidden">
        {loading && <LinearLoader />}
        <Header />
        <section className="flex-1 overflow-y-auto p-6 bg-gray-50">
          {content}
        </section>
      </main>
    </div>
  );
}